// extracted by mini-css-extract-plugin
module.exports = {"docsNearby":"doctorsnearby_docsNearby__2ndLc"};